import React, { useState } from "react";
import "./image.scss";

interface ImageProps {
  src: string | null;
  alt?: string;
  className?: string;
  fallbackSrc?: string;
}

const Image: React.FC<ImageProps> = ({
  src,
  alt = "",
  className = "",
  fallbackSrc = "/images/default-image.png",
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const imageSrc = !src || error ? fallbackSrc : src;

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* loading spinner */}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-gray-700"></div>
        </div>
      )}

      <img
        src={imageSrc}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoading(false)}
        onError={() => {
          setError(true);
          setLoading(false);
        }}
        image-card-img
        // w-full h-full object-cover transition-opacity duration-300
        className={` image-card-img ${loading ? "opacity-0" : "opacity-100"}`}
      />
    </div>
  );
};

export default Image;
